import { range } from "lodash";
import React, { Fragment } from "react";
import { useTableContext } from "../../hooks/useTableContext";
import { Placeholder } from "../../Placeholder";
import { V2Table } from "./Table";
import { V2TableCell } from "./TableCell";
import { V2TableRowComponent } from "./TableRow";
export function TableLoading(props) {
    const { gridClassName } = useTableContext();
    let rowIndex = 0;
    return (React.createElement(Fragment, null, range(props?.loadingRows ?? 4).map(() => {
        rowIndex++;
        return (React.createElement(V2TableRowComponent, { item: { dummy: "" }, rowIndex: rowIndex, ...props, key: rowIndex, gridClassName: gridClassName }, props.headings.map((heading, i) => {
            return (React.createElement(V2TableCell, { ...props, heading: heading, colIndex: i + 1, key: i },
                React.createElement(Placeholder, null)));
        })));
    })));
}
export function TableSkeleton(props) {
    return React.createElement(V2Table, { ...props, loading: true });
}
